import { createTheme } from "@mui/material/styles";
import { tokens } from "./tokens";

const c = tokens.color;

// Світла тема, узгоджена з лендінгом clean-hands-club.
const theme = createTheme({
  palette: {
    mode: "light",
    background: {
      default: c.bg,
      paper: c.surface,
    },
    primary: {
      main: c.gold,
      dark: c.goldDeep,
      contrastText: c.ink, // темний текст на золотому — читабельно
    },
    secondary: {
      main: c.olive,
    },
    text: {
      primary: c.ink,
      secondary: c.inkSoft,
    },
    error: { main: c.error },
    success: { main: c.success },
    divider: c.line,
  },
  typography: {
    fontFamily: tokens.font.family,
    fontSize: 14,
    h4: { fontWeight: 600, letterSpacing: "0.02em" },
    h5: { fontWeight: 600, letterSpacing: "0.02em" },
    h6: { fontWeight: 600 },
    button: { fontWeight: 600, letterSpacing: "0.02em" },
  },
  shape: { borderRadius: tokens.radius.md },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: { backgroundColor: c.dark, color: c.onDark },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 10, textTransform: "none" },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          backgroundColor: c.surface,
          border: `1px solid ${c.line}`,
          borderRadius: tokens.radius.md,
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: { backgroundColor: c.gold },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { backgroundColor: c.gold, color: c.ink, fontWeight: 500 },
      },
    },
  },
});

export default theme;
